import { observer } from 'mobx-react-lite'
import { useLocation, useNavigate } from 'react-router-dom'
import useStore from 'reusable/mobx-store-utils'
import { useOrgGuardStore } from '../OrgGuardStore'
import RouterStore, { RouterStoreProvider } from '../RouterStore'
import GuestRouter from './GuestRouter'
import WebSocketProvider from 'websockets/WebSocketProvider'
import { useRegionRouterStore } from 'features/main/RegionRouterStore'

export default observer(function GuestContainer() {
   const orgGuardStore = useOrgGuardStore()
   const location = useLocation()
   const navigate = useNavigate()
   const regionRouterStore = useRegionRouterStore()
   const routerStore = useStore(sp => new RouterStore(sp), { navigate, orgGuardStore, location, regionRouterStore })

   return (
      <RouterStoreProvider store={routerStore}>
         <WebSocketProvider>
            <GuestRouter />
         </WebSocketProvider>
      </RouterStoreProvider>
   )
})
